import React from 'react'
import { useSetActiveModal } from 'src/Modal/ModalStateContext'
import { useCurrentFormAuditId } from 'src/context/FormContext/CurrentFormAuditContext'
import { BasicDropdownMenuItem } from 'src/components/Reusable/BasicDropdown/BasicDropdown.styles'
import { ModalFormId } from '../../../../components/ModalForms'

type Props = {
  eventKey: string
  auditId: string
}

export const EditAudit = ({ eventKey, auditId }: Props): JSX.Element => {
  const openModal = useSetActiveModal(ModalFormId.EDIT_AUDIT)
  const { setAuditId } = useCurrentFormAuditId()

  const handleClick = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    e.preventDefault()
    openModal()
    setAuditId(auditId)
  }

  return (
    <BasicDropdownMenuItem eventKey={eventKey} onClick={handleClick}>
      Edit Audit
    </BasicDropdownMenuItem>
  )
}
